var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("transition", { attrs: { name: "fade" } }, [
    _c("div", { staticClass: "w-100" }, [
      _vm.stage
        ? _c("div", [
            _c(
              "span",
              { staticClass: "h5 text-dark font-weight-bold d-block" },
              [
                _vm._v(
                  "\n        Step " +
                    _vm._s(_vm.stage.step - (_vm.progress ? 0 : 1)) +
                    " of " +
                    _vm._s(_vm.totalSteps - (_vm.progress ? 0 : 1)) +
                    "\n      "
                ),
              ]
            ),
            _vm._v(" "),
            _c("span", { staticClass: "text-secondary small mb-3 d-block" }, [
              _vm._v("\n        " + _vm._s(_vm.stage.label) + " ...\n      "),
            ]),
          ])
        : _c("div", { staticClass: "text-muted h5" }, [
            _vm._v("\n      Preparing...\n    "),
          ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "progress",
          staticStyle: { height: "20px", "border-radius": "10px" },
        },
        [
          _c(
            "div",
            {
              staticClass: "progress-bar bg-primary",
              style: { width: _vm.progressPercent + "%" },
              attrs: {
                role: "progressbar",
                "aria-valuenow": _vm.progressPercent,
                "aria-valuemin": "0",
                "aria-valuemax": "100",
              },
            },
            [_vm._v("\n        " + _vm._s(_vm.progressPercent) + "%\n      ")]
          ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }